
(function () {
  function initAnnouncementSliders(root = document) {
    const sliders = [];

    if (root.matches?.('[data-announcement-slider]')) {
      sliders.push(root);
    }

    sliders.push(...root.querySelectorAll('[data-announcement-slider]'));

    sliders.forEach((slider) => {
      if (slider.dataset.sliderInitialized === 'true') return;
      slider.dataset.sliderInitialized = 'true';

      const slides = Array.from(
        slider.querySelectorAll('[data-announcement-slide]')
      );

      const prev = slider.querySelector('[data-announcement-prev]');
      const next = slider.querySelector('[data-announcement-next]');

      if (slides.length < 2) return;

      let current = 0;
      let timer = null;

      const delay = Math.max(
        3000,
        Number(slider.dataset.slideDelay) || 7000
      );

      
        function showSlide(index) {
        current = (index + slides.length) % slides.length;

        slides.forEach((slide, i) => {
            const active = i === current;

            slide.hidden = false;
            slide.classList.toggle('is-active', active);
            slide.setAttribute('aria-hidden', String(!active));

            if ('inert' in slide) {
            slide.inert = !active;
            }
        });
        }


      function stopAutoplay() {
        if (timer !== null) {
          clearInterval(timer);
          timer = null;
        }
      }

      function startAutoplay() {
        stopAutoplay();

        if (
          window.matchMedia('(prefers-reduced-motion: reduce)').matches
        ) {
          return;
        }

        timer = setInterval(() => {
          showSlide(current + 1);
        }, delay);
      }

      prev?.addEventListener('click', () => {
        showSlide(current - 1);
        startAutoplay();
      });

      next?.addEventListener('click', () => {
        showSlide(current + 1);
        startAutoplay();
      });

      slider.addEventListener('mouseenter', stopAutoplay);
      slider.addEventListener('mouseleave', startAutoplay);

      slider.addEventListener('focusin', stopAutoplay);
      slider.addEventListener('focusout', (event) => {
        if (!slider.contains(event.relatedTarget)) {
          startAutoplay();
        }
      });

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          stopAutoplay();
        } else {
          startAutoplay();
        }
      });

      if (window.Shopify && Shopify.designMode) {
        document.addEventListener('shopify:block:select', (event) => {
          const index = slides.findIndex(
            (slide) => slide.contains(event.target) ||
              slide === event.target
          );

          if (index !== -1) {
            stopAutoplay();
            showSlide(index);
          }
        });
      }

      showSlide(0);
      startAutoplay();
    });
  }

  function initialize() {
    initAnnouncementSliders(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAnnouncementSliders(event.target);
  });
})();
